import { render, staticRenderFns } from "./ResendVerificationText.vue?vue&type=template&id=606d0a40&"
import script from "./ResendVerificationText.vue?vue&type=script&lang=js&"
export * from "./ResendVerificationText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports